const multipleStringReplace = (stringTemplate, optionsObject) => {
	return Object.entries(optionsObject).reduce(
		(prev, [key, value]) => prev.replace(`[${key}]`, value),
		stringTemplate
	)
}

export default multipleStringReplace
